import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=56bfd132&scoped=true&"
import script from "./ButtonComponent.vue?vue&type=script&lang=js&"
export * from "./ButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./ButtonComponent.vue?vue&type=style&index=0&id=56bfd132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bfd132",
  null
  
)

export default component.exports